import { find, findAll, register } from '../../../../Javascript/Sysmex/Utils'
import ContentRouter from '../../../../Javascript/Libraries/ContentRouter'

const Tabs = el => {
  const router = new ContentRouter(el, 'tabs', { parent: 'sysmexAtomTab_tab', clickable: 'sysmexAtomTab_title' }) // kann init hier anhängen?
  router.init()

  let titlesWidth = 0
  const titlesContainer = find('[data-titles]', el)
  const titlesInner = find('[data-inner-titles]', el)
  const indicatorBefore = find('[data-before]', el)
  const indicatorAfter = find('[data-after]', el)
  const underline = find('[data-underline]', el)
  const underlineHover = find('[data-underline-hover]', el)

  const tabs = findAll('[data-tab]', el)
  const titles = findAll('[data-title]', el)
  const contents = findAll('[data-content]', el)
  titles.forEach(title => titlesInner.appendChild(title))

  if (titles && titles.length > 0) {
    titles[0].classList.add('sysmexAtomTab_tab--isActive')
    contents[0].classList.add('sysmexAtomTab_tab--isActive')
    underline.style.width = (titles[0].offsetWidth - 23) + 'px'
    underlineHover.style.width = 0
  }

  tabs.forEach((tab, index) => {
    const title = titles[index]
    const content = contents[index]

    title.addEventListener('click', () => {
      titles.forEach(content => content.classList.remove('sysmexAtomTab_tab--isActive'))
      contents.forEach(content => content.classList.remove('sysmexAtomTab_tab--isActive'))

      title.classList.add('sysmexAtomTab_tab--isActive')
      content.classList.add('sysmexAtomTab_tab--isActive')

      underline.style.width = title.offsetWidth + 'px'
      underline.style.transform = 'translateX(' + title.offsetLeft + 'px)'
    })

    title.addEventListener('mouseover', () => {
      underlineHover.style.width = title.offsetWidth + 'px'
      underlineHover.style.transform = 'translate(' + title.offsetLeft + 'px,-4px)'
      underlineHover.style.opacity = 1
    })

    title.addEventListener('mouseout', () => {
      underlineHover.style.opacity = 0
    })
    if (title.dataset.anchor === window.location.hash.split('#').find(h => h.includes('tab-'))) {
      title.click()
    }
  })

  const titleArray = Array.from(titlesInner.children)

  titleArray.forEach(child => {
    const style = child.currentStyle || window.getComputedStyle(child)
    titlesWidth += child.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
  })

  const widthDifference = titlesWidth - titlesInner.offsetWidth - 5

  if (titlesWidth > titlesInner.offsetWidth) {
    indicatorAfter.classList.add('sysmexMoleculeTabContainer_has--indicators')
    indicatorBefore.classList.add('sysmexMoleculeTabContainer_has--indicators')
    indicatorAfter.classList.add('sysmexMoleculeTabContainer_is--visible')
  }

  titlesContainer.onscroll = function () {
    if (titlesContainer.scrollLeft > 5) {
      indicatorBefore.classList.add('sysmexMoleculeTabContainer_is--visible')
    } else {
      indicatorBefore.classList.remove('sysmexMoleculeTabContainer_is--visible')
    }

    if (titlesContainer.scrollLeft < widthDifference) {
      indicatorAfter.classList.add('sysmexMoleculeTabContainer_is--visible')
    } else {
      indicatorAfter.classList.remove('sysmexMoleculeTabContainer_is--visible')
    }
  }

  indicatorAfter.addEventListener('click', (e) => {
    scroll('right', e.target)
  })

  indicatorBefore.addEventListener('click', (e) => {
    scroll('left', e.target)
  })

  const scroll = (direction, target) => {
    target.classList.add('sysmexMoleculeTabContainer_is--scrolling')
    const duration = 1000
    const start = titlesContainer.scrollLeft
    const change = (direction === 'right') ? titlesInner.offsetWidth : -titlesInner.offsetWidth
    let currentTime = 0
    const increment = 20

    const animateScroll = function () {
      currentTime += increment
      const val = Math.easeInOutQuad(currentTime, start, change, duration)
      titlesContainer.scrollLeft = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      } else {
        target.classList.remove('sysmexMoleculeTabContainer_is--scrolling')
      }
    }
    animateScroll()
  }

  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
}

register('Tabs', Tabs)
